/* ==========================================================================
   ROMANTICO - <sticky-atc>
   Shows the sticky bar once the main add-to-cart button has scrolled out of
   view, and keeps its own variant <select> in sync (id + price + availability).
   The cart submission itself is handled by Dawn's <product-form>.
   ========================================================================== */
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.target =
          document.querySelector('.product__info-wrapper .product-form__submit') ||
          document.querySelector('.product__info .product-form__submit');
        this.select = this.querySelector('.sticky-atc__variant');
        this.idInput = this.querySelector('.sticky-atc__id');
        this.priceEl = this.querySelector('.sticky-atc__price');
        this.submit = this.querySelector('.sticky-atc__submit');

        if (this.select) {
          this._onChange = this.onVariantChange.bind(this);
          this.select.addEventListener('change', this._onChange);
        }

        this.ticking = false;
        this._onScroll = () => {
          if (!this.ticking) {
            window.requestAnimationFrame(this.update.bind(this));
            this.ticking = true;
          }
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        if (this.select && this._onChange) this.select.removeEventListener('change', this._onChange);
      }

      update() {
        this.ticking = false;
        if (!this.target) return;
        var r = this.target.getBoundingClientRect();
        // visible once the main add-to-cart has scrolled above the viewport
        this.classList.toggle('is-visible', r.bottom < 0);
      }

      onVariantChange() {
        var opt = this.select.options[this.select.selectedIndex];
        if (!opt) return;
        if (this.idInput) this.idInput.value = opt.value;
        if (this.priceEl && opt.dataset.price) this.priceEl.innerHTML = opt.dataset.price;
        var available = opt.dataset.available === 'true';
        if (this.submit) {
          this.submit.disabled = !available;
          var label = this.submit.querySelector('span');
          if (label) label.textContent = available ? this.submit.dataset.addLabel : this.submit.dataset.soldLabel;
        }
      }
    }
  );
}
